/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export interface IAutomation {
  selectedTab: string;
}

export const initialState: IAutomation = {
  selectedTab: '',
};

const Automation = createSlice({
  name: 'automation',
  initialState,
  reducers: {
    setSelectedTab: (state, action) => {
      state.selectedTab = action.payload;
    },
  },
});

export const automationActions = Automation.actions;
export default Automation.reducer;
